<script>
import { preventDefault } from 'svelte/legacy';
import {
    onMount
} from 'svelte';
import { lockState } from "@app/store/lockStore.svelte.js";
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    playerState
} from '@app/store/playerStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    styleState, selectPreset, initializePresets, savePreset as savePresetToStore, deletePreset as deletePresetFromStore
} from '@app/store/styleStore.svelte.js';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    authState
} from '@app/store/authStore.svelte.js';
import {
    fontState
} from '@app/store/fontStore.svelte.js';
import {
    fade
} from 'svelte/transition';
import Swal from 'sweetalert2'
import { SWAL_BASE, SWAL_CLASSES } from '@app/lib/swalClasses.js';
import { activateSubscription } from '@app/lib/activateSubscription.js';
import {
    v4 as uuidv4
} from 'uuid';
import {
    BarLoader
} from 'svelte-loading-spinners';
/* CC LIB */
import encode from "@cclib/functions/encode.js";
import defaults from "@cclib/lib/defaults.js";
import tcLib from "@cclib/lib/timecode.js";
import _Event from "@cclib/classes/event.js";
import _EventGroup from "@cclib/classes/eventGroup.js";
import ffmpegPresets from "@cclib/dict/ffmpegPresets.js"; 
import orderByTime from "@cclib/functions/eventGroups/orderByTime.js";
import removeHtmlEntities from "@cclib/functions/eventGroups/removeHtmlEntities.js";
import reorderRtlText from "@cclib/functions/utility/reorderRtlText.js";
import wrapStyledTextWithSpan from '@cclib/functions/quill/wrapStyledTextWithSpan.js'; 
import replaceTrialText from "@cclib/functions/eventGroups/replaceTrialText.js";
import * as m from "@app/paraglide/messages.js";
import TcRangeSlider from '@app/components/inputs/TcRangeSlider.svelte';

/* Export Preset Store */
import {
    createPreset as createExportPreset,
    getPresetsByType,
    getPresetById,
    PRESET_TYPES
} from "@app/store/presetStore.svelte.js";

/* Electron/FFMPEG */
const {
    shell
} = window;
const ipcRenderer = window.ipcRenderer;
const ffmpeg = window.ffmpeg;
const execFile = window.execFile;
const os = window.os;
const path = window.path;

// Get ffmpeg path (unpacked from asar)
const ffmpegPath = window.ffmpegPath.replace('app.asar', 'app.asar.unpacked');

let targetFolderPath = $state(sessionStorage.getItem("videoExportPath")),
    //Get preset from cc-video-export-preset in localstorage
    preset = $state(localStorage.getItem("cc-video-export-preset") || "fb720"),
    progress = $state(0),
    exporting = $state(false),
    eventGroup = $state(eventGroupState[projectState.selected].id),
    duration,
    fps = $state(0),
    statusMsg = $state(""),
    tempDir = os.tmpdir(),
    retry = $state(false),
    ignoreAll = false,
    // Style-related state
    showStylePanel = $state(false),
    previewImageSrc = $state(""),
    generatingPreview = $state(false),
    selectedEventIndex = $state(0),
    showMagnifiedPreview = $state(false),
    // Export preset related state
    availableExportPresets = $derived(getPresetsByType(PRESET_TYPES.VIDEO)),
    selectedExportPresetId = $state(null),
    // Segment (in/out point) export state
    exportSegment = $state(false),
    mediaDuration = $derived(playerState.duration || projectState.media?.info?.duration || 0),
    rangeStartSec = $state(0),
    rangeEndSec = $state(0);

/* A segment only applies once we know how long the media is and the range is valid */
let segmentActive = $derived(exportSegment && mediaDuration > 0 && rangeEndSec > rangeStartSec),
    exportStartSec = $derived(segmentActive ? rangeStartSec : 0),
    exportDurationSec = $derived(segmentActive ? rangeEndSec - rangeStartSec : (mediaDuration || 500));

/* Default the out point to the end of the media as soon as the duration is known */
$effect(() => {
    if (rangeEndSec === 0 && mediaDuration > 0) {
        rangeEndSec = mediaDuration;
    }
});

    projectState.dropFrame =  projectState.dropFrame && [29.97, 59.94].indexOf(projectState.frameRate) > -1 ? true : false;

if (authState.status === "in_trial"){
    showTrialWarning();
}

async function cancelExport(eventGroupId, eventId) {
    toast.push(m.video_export_aborted_toast(), {classes: ['toast-warning']});
    
    projectState.selected = eventGroupId;
    eventGroupState[projectState.selected].selected = [eventId];    setTimeout(() =>{
        const selectedIndex = eventGroupState[projectState.selected].selected[0];
        
        // Dispatch custom event to scroll to the selected event
        window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
            detail: { index: selectedIndex }
        }));

        if (lockState.video && player){
            player.currentTime = eventGroupState[projectState.selected].events[selectedIndex].start;
        }
    }, 250);

    hideModal();
}

function alertUser(msg) {
    let response = Swal.fire({
        ...SWAL_BASE,
        titleText: m.video_export_precheck_title(),
        text : msg,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: m.video_export_precheck_abort(),
        denyButtonText: m.video_export_precheck_ignore(),
        cancelButtonText: m.video_export_precheck_ignore_all(),
        allowOutsideClick : false,
        allowEscapeKey : false,
        customClass: SWAL_CLASSES.precheck,
    }).then((result) => {
        if (result.isConfirmed) {
            return true;
        } else if (result.isDenied) {
            return false;
        } else if (result.isDismissed){
            ignoreAll = true;
            return false;
        }
    });

    return response;
}

async function preExportCheck(events) {
    for (let i = 0; i < events.length; i++) {
        if (!ignoreAll) {
            if (events[i].text) {
                if (isNaN(events[i].start)) {
                    if (await alertUser(m.video_export_event_missing_start({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (isNaN(events[i].end)) {
                    if (await alertUser(m.video_export_event_missing_end({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (events[i].start === events[i].end) {
                    if (await alertUser(m.video_export_event_same_time({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (events[i].start > events[i].end) {
                    if (await alertUser(m.video_export_event_start_after_end({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (i > 0 && events[i].start < events[i - 1].end) {
                    /* Adding check in case overlap is less than a frame */
                    if (events[i - 1].end-events[i].start < 1/projectState.frameRate){
                        events[i].start = events[i - 1].end;
                    } else if (await alertUser(m.video_export_event_overlap({ index: i + 1 }))) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                }
            } else {
                if (await alertUser(m.video_export_event_missing_text({ index: i + 1 }))) {
                    return {
                        err: true,
                        eventId: i
                    }
                };
            }
        }
        
    }

    return {
        err: false
    }
}

/* Timecode formatted for a filename - colons are not legal in file names */
function tcForFileName(sec) {
    return tcLib.secToTc(sec + projectState.incode, projectState.frameRate, projectState.dropFrame).replace(/[:;]/g, "-");
}

function getOutputFileName() {
    const rangeSuffix = segmentActive ? `_${tcForFileName(rangeStartSec)}_${tcForFileName(rangeEndSec)}` : "";

    return projectState.name + rangeSuffix + "." + ffmpegPresets.profiles[preset].ext;
}

function getOutputFilePath() {
    return path.join(targetFolderPath, getOutputFileName());
}

function checkFileExistsSync(filePath) {
    try {
        window.fsSync.accessSync(filePath);
        return true;
    } catch (error) {
        return false;
    }
}

function confirmOverwrite(fileName) {
    return Swal.fire({
        ...SWAL_BASE,
        titleText: m.video_export_file_exists_title(),
        text: m.video_export_file_exists_text({ fileName }),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.video_export_file_exists_confirm(),
        denyButtonText: m.video_export_file_exists_cancel(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: SWAL_CLASSES.denyCancel,
    }).then((result) => result.isConfirmed);
}

function showTrialWarning(){
    Swal.fire({
        ...SWAL_BASE,
        titleText: m.video_export_trial_title(),
        text : m.video_export_trial_text(),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.video_export_trial_activate(),
        denyButtonText: m.video_export_trial_continue(),
        allowOutsideClick : false,
        allowEscapeKey : false,
        customClass: SWAL_CLASSES.trial,
    }).then((result) => {
        if (result.isConfirmed) {
            activateSubscription();
        }
    }).catch(err =>{
        console.log(err);
        console.log(err.message)
    });
}

function selectTargetFolder() {
    ipcRenderer.invoke('selectFolder', {
        title : m.video_export_select_folder_title(),
        properties: ["openDirectory", "createDirectory"]
    }).then((path) => {
        if (!path.canceled) {
            targetFolderPath = path.filePaths[0];            
            sessionStorage.setItem("videoExportPath", targetFolderPath);
        }
    });
}

function updateProgress(tc, duration) {
    let tcSec = tcLib.tcMsToSec(tc);
    progress = ((tcSec.toFixed(2)/duration) * 100).toFixed(2);
    //console.log(tcSec, progress);
}

/* Drop events outside the selected segment and rebase the remainder to the
   start of the clip, since ffmpeg resets the output timestamps to zero. Events
   straddling a boundary are clamped rather than dropped so a caption already on
   screen at the in point stays visible. */
function trimEventGroupToRange(eventGroup) {
    if (!segmentActive) {
        return eventGroup;
    }

    const startSec = exportStartSec;
    const endSec = rangeEndSec;

    eventGroup.events = eventGroup.events
        .filter(event => event.end > startSec && event.start < endSec)
        .map(event => ({
            ...event,
            start: Math.max(0, Math.max(event.start, startSec) - startSec),
            end: Math.max(0, Math.min(event.end, endSec) - startSec)
        }));

    if (eventGroup.events.length === 0) {
        toast.push(m.video_export_segment_no_events_warning(), {classes: ['toast-warning']});
    }

    return eventGroup;
}

function buildAssEncodeOptions(videoWidth, videoHeight) {
    return new defaults.options({
        profile: 'subStationAlpha',
        formatOptions: [
            { name: "Border Style", selected: styleState.borderStyle },
            { name: "Font Family", selected: styleState.fontFamily },
            { name: "Font Size", selected: styleState.fontSize },
            { name: "Font Color", selected: styleState.color },
            { name: "Opacity", selected: styleState.opacity },
            { name: "Letter Spacing", selected: styleState.spacing },
            { name: "Shadow Size (px)", selected: styleState.shadow },
            { name: "Shadow Color", selected: styleState.shadowColor },
            { name: "Shadow Opacity", selected: styleState.shadowOpacity },
            { name: "Outline Size (px)", selected: styleState.outline },
            { name: "Outline Color", selected: styleState.outlineColor },
            { name: "Outline Opacity", selected: styleState.outlineOpacity },
            { name: "ScaleX", selected: styleState.scaleX },
            { name: "ScaleY", selected: styleState.scaleY },
            { name: "Video Width", selected: parseInt(videoWidth) },
            { name: "Video Height", selected: parseInt(videoHeight) },
            { name: "Margin X", selected: parseInt(videoWidth) * (styleState.xPadding / 100) },
            { name: "Margin Y", selected: parseInt(videoHeight) * (styleState.yPadding / 100) }
        ],
        frameRate: projectState.frameRate,
        dropFrame: projectState.dropFrame,
        incode: "00:00:00:00",
        window: {
            width: styleState.width,
            height: styleState.height,
            xPadding: styleState.xPadding,
            yPadding: styleState.yPadding
        }
    });
}

// Export video with alpha channel using colorkey filter (similar to ImageExport)
async function exportVideoWithAlpha() {
    try {
        toast.push(m.video_export_alpha_starting_toast(), {classes: ['toast-info']});
        localStorage.setItem("cc-video-export-preset", preset);
        
        exporting = true;
        duration = exportDurationSec;
        
        let outputFilePath = getOutputFilePath();
        let subtitleFilePath = path.join(targetFolderPath, `${projectState.id}.ass`);
        let formattedSubPath = subtitleFilePath.substring(1, 2) === ":" ? subtitleFilePath.substring(2) : subtitleFilePath;
        formattedSubPath = formattedSubPath.replace(/\\/g, "/");
        
        // Get the event group we need to export
        let eventGroupIndex = eventGroupState.findIndex(group => group.id === eventGroup);
        
        let videoWidth = ffmpegPresets.profiles[preset].scale.h;
        let videoHeight = ffmpegPresets.profiles[preset].scale.v;
        
        let copyOfEventGroup = JSON.parse(JSON.stringify(eventGroupState[eventGroupIndex]));
        
        if (copyOfEventGroup.rtl) {
            copyOfEventGroup = reorderRtlText(copyOfEventGroup);
        }
        
        let options = buildAssEncodeOptions(videoWidth, videoHeight);
        
        console.log("Encoding subtitle contents for alpha export");
        
        if (authState.status === "in_trial") {
            copyOfEventGroup = replaceTrialText(copyOfEventGroup);
        }
        
        let newEventGroup = copyOfEventGroup;
        newEventGroup = orderByTime(newEventGroup);
        newEventGroup = removeHtmlEntities(newEventGroup);
        
        let preCheckResult = await preExportCheck(newEventGroup.events);
        if (preCheckResult.err) {
            cancelExport(eventGroupIndex, preCheckResult.eventId);
            return;
        }
        
        /* Trim after the pre-check so reported event numbers match the real ones */
        newEventGroup = trimEventGroupToRange(newEventGroup);
        
        newEventGroup.events.forEach((event, index, events) => {
            events[index].text = wrapStyledTextWithSpan(event.text);
        });
        
        let subtitleContents = await encode(newEventGroup, options);
        await window.fs.writeFile(subtitleFilePath, subtitleContents);
        
        console.log("Starting FFmpeg alpha export...");
        statusMsg = m.video_export_alpha_status_exporting();
        
        // Build FFmpeg command for alpha export
        // Uses green screen background with colorkey filter to create transparency
        // Using tight colorkey settings (similarity=0.01) for clean edges
        const args = [
            "-f", "lavfi",
            "-i", `color=c=0x00FF00:s=${videoWidth}x${videoHeight}:r=${projectState.frameRate}:d=${duration}`,
            "-vf", `ass='${formattedSubPath}',colorkey=0x00FF00:similarity=0.25:blend=0.3,despill=green`,
            "-c:v", ffmpegPresets.profiles[preset].codec,
            "-b:v", ffmpegPresets.profiles[preset].bitrate || "25000k",
            "-pix_fmt", ffmpegPresets.profiles[preset].pixelFormat
        ];
        
        // Add ProRes profile if specified (profile 4 = ProRes 4444)
        if (ffmpegPresets.profiles[preset].profile !== undefined) {
            args.push("-profile:v", ffmpegPresets.profiles[preset].profile.toString());
        }
        
        // Add alpha bits for ProRes 4444
        if (ffmpegPresets.profiles[preset].alphaBits) {
            args.push("-alpha_bits", ffmpegPresets.profiles[preset].alphaBits.toString());
        }
        
        args.push("-y", outputFilePath);
        
        console.log("Alpha FFmpeg command:", ffmpegPath, args.join(" "));
        
        // Use execFile for direct control over the process
        const ffmpegProcess = execFile(ffmpegPath, args);
        
        ffmpegProcess.stderr.on('data', (data) => {
            const output = data.toString();
            console.log("FFmpeg:", output);
            
            // Parse progress from FFmpeg output
            const timeMatch = output.match(/time=(\d{2}):(\d{2}):(\d{2})\.(\d{2})/);
            if (timeMatch) {
                const hours = parseInt(timeMatch[1]);
                const minutes = parseInt(timeMatch[2]);
                const seconds = parseInt(timeMatch[3]);
                const currentTime = hours * 3600 + minutes * 60 + seconds;
                progress = ((currentTime / duration) * 100).toFixed(2);
                statusMsg = m.video_export_alpha_progress({ percent: progress });
            }
        });
        
        ffmpegProcess.on('close', async (code) => {
            if (code === 0) {
                toast.push(m.video_export_alpha_complete_toast(), { classes: ['toast-success'] });
                statusMsg = m.video_export_status_export_complete();
                progress = 100;
                exporting = false;
                
                // Clean up subtitle file
                await window.fs.unlink(subtitleFilePath).catch(console.error);
                
                shell.showItemInFolder(outputFilePath);
                hideModal();
            } else {
                toast.push(m.video_export_alpha_failed_code_toast({ code }), { classes: ['toast-danger'] });
                statusMsg = m.video_export_status_export_failed();
                progress = 100;
                exporting = false;
            }
        });
        
        ffmpegProcess.on('error', (error) => {
            console.error("FFmpeg error:", error);
            toast.push(m.video_export_alpha_failed_toast({ error: error.message }), { classes: ['toast-danger'] });
            statusMsg = m.video_export_status_export_failed_with_error({ error: error.message });
            progress = 100;
            exporting = false;
        });
        
    } catch (err) {
        console.error("Alpha export error:", err);
        toast.push(m.video_export_alpha_failed_toast({ error: err.message }), { classes: ['toast-danger'] });
        progress = 100;
        exporting = false;
    }
}

async function exportVideo() {
    if (!retry) {
        const outputPath = getOutputFilePath();
        if (checkFileExistsSync(outputPath)) {
            const proceed = await confirmOverwrite(getOutputFileName());
            if (!proceed) {
                return;
            }
        }
    }

    // Check if this is an alpha channel preset and route accordingly
    if (ffmpegPresets.profiles[preset].alphaChannel) {
        return exportVideoWithAlpha();
    }
    
    try {
        toast.push(m.video_export_exporting_toast(), {classes: ['toast-info']});
        //Save preset to cc-video-export-preset in localstorage
        localStorage.setItem("cc-video-export-preset", preset);
        
        exporting = true;
        duration = exportDurationSec;
        let outputFilePath = (process.platform !== "win32" ? path.sep : "") + path.join(...targetFolderPath.split(path.sep), getOutputFileName());
        let subtitleFilePath = targetFolderPath + "\\" + `${projectState.id}.ass`;
        subtitleFilePath = subtitleFilePath.substring(1, 2) === ":" ? subtitleFilePath.substring(2) : subtitleFilePath;
        subtitleFilePath = subtitleFilePath.replace(/\\/g, "/");

        /* Tempt Backup */
        let outputFilePathTemp = (process.platform !== "win32" ? path.sep : "") + path.join(...os.tmpdir().split(path.sep), getOutputFileName());        
        let subtitleFilePathTemp = os.tmpdir() + "\\" + `${projectState.id}.ass`;
        subtitleFilePathTemp = subtitleFilePathTemp.substring(1, 2) === ":" ? subtitleFilePathTemp.substring(2) : subtitleFilePathTemp;
        subtitleFilePathTemp = subtitleFilePathTemp.replace(/\\/g, "/");

        if (retry){
            outputFilePath = outputFilePathTemp;
            subtitleFilePath = subtitleFilePathTemp;
        }

        // console.log(outputFilePath, subtitleFilePath);

        /* 1. Export ASS file with styling */
        /* Get the event group we need to export */
        let eventGroupIndex = eventGroupState.findIndex(group => {
            return group.id === eventGroup;
        });

        /* Translate for Creator */
        let videoWidth = ffmpegPresets.profiles[preset].crop ? ffmpegPresets.profiles[preset].crop.h : ffmpegPresets.profiles[preset].scale.h;
        let videoHeight = ffmpegPresets.profiles[preset].crop ? ffmpegPresets.profiles[preset].crop.v : ffmpegPresets.profiles[preset].scale.v;
        
        /* console.log("------------------");
        console.log(fontSize, styleState.fontSize,playerWidth,playerHeight,window.screen.availWidth,window.devicePixelRatio, videoWidth);
        console.log("------------------"); */

        let copyOfEventGroup = JSON.parse(
            JSON.stringify(eventGroupState[eventGroupIndex]),
        );

        if (copyOfEventGroup.rtl){
            copyOfEventGroup = reorderRtlText(copyOfEventGroup);
        }

        let options = buildAssEncodeOptions(videoWidth, videoHeight);

        console.log("Encoding subtitle contents");      

        if (authState.status === "in_trial") {
            copyOfEventGroup = replaceTrialText(copyOfEventGroup);
        }

        try {
            let newEventGroup = copyOfEventGroup;
            newEventGroup = orderByTime(newEventGroup);
            newEventGroup = removeHtmlEntities(newEventGroup);
            let preCheckResult = await preExportCheck(newEventGroup.events);
            if (preCheckResult.err) {
                cancelExport(eventGroupIndex, preCheckResult.eventId);
                return;
            }

            /* Trim after the pre-check so reported event numbers match the real ones */
            newEventGroup = trimEventGroupToRange(newEventGroup);

            newEventGroup.events.forEach((event, index, events) =>{
                events[index].text = wrapStyledTextWithSpan(event.text);
            });

            let subtitleContents = await encode(newEventGroup, options);
            console.log("Writing subtitle file to disk...");
            await window.fs.writeFile(subtitleFilePath, subtitleContents);
        } catch(err){
            console.log("Subtitle encoding failed");
            throw new Error("Subtitle encoding failed with message: "+err.message);
        }
        

        console.log("Starting FFMPEG...");
        /* 2. Start Export */
        let command = ffmpeg(projectState.media.localPath);

        /* Segment export: -ss before the input (fast seek, output timestamps
           restart at zero) and -t on the output */
        if (segmentActive){
            command.seekInput(exportStartSec);
            command.duration(exportDurationSec);
        }
        
        // Add hardware acceleration if specified
        if (ffmpegPresets.profiles[preset].hwaccel){
            command.inputOptions(`-hwaccel auto`);
        }
        
        if (ffmpegPresets.profiles[preset].scale){
            command.videoFilters(`scale=${ffmpegPresets.profiles[preset].scale.h}:${ffmpegPresets.profiles[preset].scale.v}`);
        }

        if (ffmpegPresets.profiles[preset].crop){
            command.videoFilters(`crop=${ffmpegPresets.profiles[preset].crop.h}:${ffmpegPresets.profiles[preset].crop.v}`);
        }

        if (!ffmpegPresets.profiles[preset].proxy){
            command.videoFilters(`ass=${subtitleFilePath}`);
        }

        if (ffmpegPresets.profiles[preset].pixelFormat){
            command.outputOptions(`-pix_fmt ${ffmpegPresets.profiles[preset].pixelFormat}`);
        }

        if (ffmpegPresets.profiles[preset].pixelFormat){
            command.outputOptions(`-pix_fmt ${ffmpegPresets.profiles[preset].pixelFormat}`);
        }

        /* ProRes */
        if (ffmpegPresets.profiles[preset].profile !== undefined){
            command.outputOptions(`-profile:v ${ffmpegPresets.profiles[preset].profile}`);
        }

        if (ffmpegPresets.profiles[preset].aCodec){
            command.audioCodec(ffmpegPresets.profiles[preset].aCodec);
        }

        if (ffmpegPresets.profiles[preset].bitrate){
            command.videoBitrate(ffmpegPresets.profiles[preset].bitrate || 12000000);
        }
        
        // Add preset option for hardware encoding if specified
        if (ffmpegPresets.profiles[preset].preset){
            command.outputOptions(`-preset ${ffmpegPresets.profiles[preset].preset}`);
        }

        command.videoCodec(ffmpegPresets.profiles[preset].codec)            
            .output(outputFilePath)
            .on('start', function(commandLine) {
                console.log('Spawned Ffmpeg with command: ' + commandLine);
            })
            .on('codecData', function(data) {
                console.log('Input is ' + data.audio + ' audio ' +
                    'with ' + data.video + ' video');
            })
            .on('progress', function(progress) {
                /* progress = {percent, timemark, currentFps, frames, targetSize, currentKbps} */
                updateProgress(progress.timemark, duration)
                statusMsg = m.video_export_status_exporting({ timecode: progress.timemark });
                fps = progress.currentFps;
                console.log('Exporting: ' + progress.timemark + ' done', progress);
            })
            .on('end', function() {
                toast.push(m.video_export_complete_toast(), {classes: ['toast-success']});
                console.log('Finished Exporting');
                statusMsg = m.video_export_status_export_complete();
                progress = 100;
                exporting = false;
                shell.showItemInFolder(outputFilePath);
                hideModal();
            })
            .on('error', function(err, stdout, stderr) {
                if (!retry){
                    console.log("First failure... retrying.");
                    retry = true;
                    exportVideo();
                } else {
                    // console.log(err);
                    // console.log(stderr, stdout)
                    console.log("Second failure... failing.")
                    toast.push(m.video_export_failed_toast({ error: err.message }), {classes: ['toast-danger']});
                    console.log('Cannot process video: ' + err.message);
                    statusMsg = m.video_export_status_export_failed_with_error({ error: err.message });
                    progress = 100;
                    exporting = false;
                    hideModal();
                }                
            })
            .run();
    } catch (err) {
        if (!retry){
            console.log("First failure... retrying.");
            retry = true;
            exportVideo();
        } else {
            console.log(err,err.message)
            toast.push(m.video_export_process_failed_toast({ error: err.message }), {classes: ['toast-danger']});
            console.log('Video export process failed: ' + err.message);
            progress = 100;
            exporting = false;
        }        
    }
}

// Preset management functions for VideoExport modal
function savePreset() {
    Swal.fire({
        ...SWAL_BASE,
        titleText: m.video_export_save_preset_title(),
        text: m.video_export_save_preset_text(),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.video_export_save_preset_confirm(),
        denyButtonText: m.video_export_save_preset_cancel(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        inputLabel: m.video_export_preset_name_label(),
        inputValue: styleState.selectedPreset?.name || m.video_export_preset_default_name(),
        input: "text",
        customClass: SWAL_CLASSES.denyCancel,
    })
        .then(async (result) => {
            if (result.isConfirmed) {
                const presetName = result.value;
                if (presetName) {
                    try {
                        await savePresetToStore(presetName, uuidv4);
                        toast.push(m.video_export_preset_saved(), {
                            classes: ["toast-success"],
                        });
                    } catch (error) {
                        console.error("Error saving preset:", error);
                        toast.push(error.message, {
                            classes: ["toast-danger"],
                        });
                    }
                }
            } else {
                toast.push(m.video_export_preset_save_aborted(), { classes: ["toast-info"] });
            }
        })
        .catch((err) => {
            console.error(err);
            toast.push(err.message, { classes: ["toast-danger"] });
        });
}

function deletePreset() {
    if (!styleState.selectedPreset) {
        toast.push(m.video_export_preset_none_selected(), { classes: ["toast-warning"] });
        return;
    }

    Swal.fire({
        ...SWAL_BASE,
        titleText: m.video_export_preset_delete_title(),
        text: m.video_export_preset_delete_text({ name: styleState.selectedPreset.name }),
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: m.video_export_preset_delete_confirm(),
        denyButtonText: m.video_export_preset_delete_cancel(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: SWAL_CLASSES.destructiveDeny,
    })
        .then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deletePresetFromStore();
                    toast.push(m.video_export_preset_deleted(), {
                        classes: ["toast-success"],
                    });
                } catch (error) {
                    console.error("Error deleting preset:", error);
                    toast.push(m.video_export_preset_delete_failed({ error: error.message }), {
                        classes: ["toast-danger"],
                    });
                }
            }
        })
        .catch((err) => {
            console.error(err);
            toast.push(err.message, { classes: ["toast-danger"] });
        });
}

// Initialize presets when modal opens
onMount(() => {
    if (styleState.presets.length === 0) {
        initializePresets();
    }
});

// Download preview thumbnail function
function downloadPreviewThumbnail() {
    if (!previewImageSrc) return;
    
    try {
        // Convert base64 data URL to blob
        const base64Data = previewImageSrc.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/jpeg' });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${projectState.name}_subtitle_preview_event_${selectedEventIndex + 1}.jpg`;
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up
        URL.revokeObjectURL(url);
        
        toast.push(m.video_export_preview_downloaded(), {classes: ['toast-success']});
    } catch (error) {
        console.error('Download error:', error);
        toast.push(m.video_export_preview_download_failed({ error: error.message }), {classes: ['toast-danger']});
    }
}

// Navigation functions for preview controls
function goToStart() {
    const currentEventGroup = eventGroupState.find(group => group.id === eventGroup);
    if (!currentEventGroup || !currentEventGroup.events.length) return;
    
    selectedEventIndex = 0;
    generateVideoPreview();
}

function goToPrevious() {
    const currentEventGroup = eventGroupState.find(group => group.id === eventGroup);
    if (!currentEventGroup || !currentEventGroup.events.length) return;
    
    if (selectedEventIndex > 0) {
        selectedEventIndex = selectedEventIndex - 1;
        generateVideoPreview();
    }
}

function goToNext() {
    const currentEventGroup = eventGroupState.find(group => group.id === eventGroup);
    if (!currentEventGroup || !currentEventGroup.events.length) return;
    
    if (selectedEventIndex < currentEventGroup.events.length - 1) {
        selectedEventIndex = selectedEventIndex + 1;
        generateVideoPreview();
    }
}

function goToEnd() {
    const currentEventGroup = eventGroupState.find(group => group.id === eventGroup);
    if (!currentEventGroup || !currentEventGroup.events.length) return;
    
    selectedEventIndex = currentEventGroup.events.length - 1;
    generateVideoPreview();
}

// Video preview function
async function generateVideoPreview() {
    if (!projectState.media.localPath || generatingPreview) return;
    
    generatingPreview = true;
    previewImageSrc = "";
    
    try {
        // Get the current event group and selected event
        let currentEventGroup = eventGroupState.find(group => group.id === eventGroup);
        if (!currentEventGroup || !currentEventGroup.events.length) {
            toast.push(m.video_export_preview_no_events(), {classes: ['toast-warning']});
            return;
        }
        
        // Get the selected event or first event
        let eventGroupIndex = eventGroupState.findIndex(group => {
            return group.id === eventGroup;
        });
        let eventToPreview = currentEventGroup.events[selectedEventIndex] || currentEventGroup.events[0];
        if (!eventToPreview) {
            toast.push(m.video_export_preview_no_event_selected(), {classes: ['toast-warning']});
            return;
        }
        
        eventToPreview = JSON.parse(JSON.stringify(eventToPreview));
        // Calculate timecode for preview (middle of the event)
        let previewTime = eventToPreview.start + ((eventToPreview.end - eventToPreview.start) / 2);
        eventToPreview.start = 0;
        eventToPreview.end = 5;
        
        // Generate subtitle file for preview
        let subtitleFilePath = path.join(tempDir, `preview_${Date.now()}.ass`);
        console.log("Generating subtitle file for preview at:", subtitleFilePath);
        // Copy events for processing
        let copyOfEventGroup = JSON.parse(JSON.stringify({events: [eventToPreview]}));
        
        if (copyOfEventGroup.rtl) {
            copyOfEventGroup = reorderRtlText(copyOfEventGroup);
        }
        
        // Get video dimensions
        let videoWidth = ffmpegPresets.profiles[preset].crop ? ffmpegPresets.profiles[preset].crop.h : ffmpegPresets.profiles[preset].scale.h;
        let videoHeight = ffmpegPresets.profiles[preset].crop ? ffmpegPresets.profiles[preset].crop.v : ffmpegPresets.profiles[preset].scale.v;
        let options = buildAssEncodeOptions(videoWidth, videoHeight);
        
        let newEventGroup = {
            ...(new _EventGroup({events: copyOfEventGroup.events}))
        };
        newEventGroup = orderByTime(newEventGroup);
        newEventGroup = removeHtmlEntities(newEventGroup);
        
        let subtitleContents = await encode(newEventGroup, options);
        console.log(subtitleContents);
        await window.fs.writeFile(subtitleFilePath, subtitleContents);
        subtitleFilePath = subtitleFilePath.substring(1, 2) === ":" ? subtitleFilePath.substring(2) : subtitleFilePath;
        subtitleFilePath = subtitleFilePath.replace(/\\/g, "/");
        
        // Generate preview thumbnail with subtitles
        let previewOutputPath = path.join(tempDir, `preview_${Date.now()}.jpg`);
        
        let command = ffmpeg(projectState.media.localPath);

        // Add subtitle filter (using ass filter instead of subtitles for consistency with export)
        if (!ffmpegPresets.profiles[preset].proxy) {
            command.videoFilters(`subtitles=${subtitleFilePath.replace(/\\/g, '/')}`);
        }
        
        // Apply the same video filters as the export process
        if (ffmpegPresets.profiles[preset].scale) {
            command.videoFilters(`scale=${ffmpegPresets.profiles[preset].scale.h}:${ffmpegPresets.profiles[preset].scale.v}`);
        }

        if (ffmpegPresets.profiles[preset].crop) {
            command.videoFilters(`crop=${ffmpegPresets.profiles[preset].crop.h}:${ffmpegPresets.profiles[preset].crop.v}`);
        }        
        
        return new Promise((resolve, reject) => {
            command
                .seekInput(previewTime.toFixed(3))
                .outputOptions([
                    '-vframes 1'
                ])
                .output(previewOutputPath)
                .on('start', (commandLine) => {
                    console.log('Preview FFmpeg command:', commandLine);
                })
                .on('codecData', function(data) {
                    console.log('Input is ' + data.audio + ' audio ' +
                        'with ' + data.video + ' video');
                })
                .on('progress', function(progress) {
                    /* progress = {percent, timemark, currentFps, frames, targetSize, currentKbps} */
                    console.log('Generating preview frame at: ' + progress.timemark, progress);
                })
                .on('end', () => {
                    // Convert to data URL for display
                    console.log('Preview generation complete:', previewOutputPath);
                    window.fs.readFile(previewOutputPath).then(buffer => {
                        const base64 = buffer.toString('base64');
                        previewImageSrc = `data:image/jpeg;base64,${base64}`;
                        
                        // Cleanup temp files
                        window.fs.unlink(subtitleFilePath).catch(console.error);
                        window.fs.unlink(previewOutputPath).catch(console.error);
                        
                        resolve();
                    }).catch(reject);
                })
                .on('error', (error) => {
                    console.error('Preview generation error:', error);
                    console.error('FFmpeg stderr:', error.message);
                    reject(error);
                })
                .run();
        });
        
    } catch (error) {
        console.error('Preview error:', error);
        toast.push(m.video_export_preview_failed({ error: error.message }), {classes: ['toast-danger']});
    } finally {
        generatingPreview = false;
    }
}

// Function to save current video export settings as a preset
async function saveAsExportPreset() {
    const { value: presetName } = await Swal.fire({
        ...SWAL_BASE,
        titleText: m.video_export_export_preset_save_title(),
        input: 'text',
        inputLabel: m.video_export_export_preset_name_label(),
        inputPlaceholder: m.video_export_export_preset_name_placeholder(),
        showCancelButton: true,
        confirmButtonText: m.video_export_export_preset_save_confirm(),
        cancelButtonText: m.video_export_export_preset_save_cancel(),
        customClass: SWAL_CLASSES.confirmCancel,
        inputValidator: (value) => {
            if (!value) {
                return m.video_export_export_preset_name_required();
            }
        }
    });

    if (presetName) {
        try {
            const config = {
                preset, // FFmpeg preset (fb720, etc.)
                targetFolderPath
            };
            
            Object.keys(config).forEach(key => {
                if (config[key] === undefined) {
                    delete config[key];
                }
            });

            // The preset store resolves the Firebase auth uid itself so that
            // saves land in the same collection loadPresets reads from.
            const exportPreset = await createExportPreset({
                name: presetName,
                type: PRESET_TYPES.VIDEO,
                config
            });

            toast.push(m.video_export_export_preset_saved({ name: presetName }), { classes: ['toast-success'] });
            selectedExportPresetId = exportPreset.id;
        } catch (error) {
            console.error("Error saving video export preset:", error);
            toast.push(m.video_export_export_preset_save_failed({ error: error.message }), { classes: ['toast-danger'] });
        }
    }
}

// Function to show load preset dialog
async function showLoadExportPresetDialog() {
    if (availableExportPresets.length === 0) {
        await Swal.fire({
            ...SWAL_BASE,
            title: m.video_export_export_presets_none_title(),
            text: m.video_export_export_presets_none_text(),
            icon: 'info',
            confirmButtonText: m.ok(),
            customClass: SWAL_CLASSES.ok,
        });
        return;
    }

    // Create options object for SweetAlert select
    const presetOptions = {};
    availableExportPresets.forEach(exportPreset => {
        presetOptions[exportPreset.id] = exportPreset.name;
    });

    const result = await Swal.fire({
        ...SWAL_BASE,
        title: m.video_export_export_preset_load_title(),
        input: 'select',
        inputOptions: presetOptions,
        inputPlaceholder: m.video_export_export_preset_load_placeholder(),
        showCancelButton: true,
        confirmButtonText: m.video_export_export_preset_load_confirm(),
        cancelButtonText: m.video_export_export_preset_load_cancel(),
        customClass: SWAL_CLASSES.confirmCancel,
        inputValidator: (value) => {
            if (!value) {
                return m.video_export_export_preset_load_required();
            }
        }
    });

    if (result.isConfirmed && result.value) {
        selectedExportPresetId = result.value;
        loadExportPreset(result.value);
    }
}

// Function to load a video export preset
function loadExportPreset(presetId) {
    if (!presetId) return;

    const exportPreset = getPresetById(presetId);
    if (!exportPreset || !exportPreset.config) {
        toast.push(m.video_export_export_preset_not_found(), { classes: ['toast-warning'] });
        return;
    }

    const config = exportPreset.config;
    
    // Apply config values
    if (config.preset) preset = config.preset;
    if (config.targetFolderPath) {
        targetFolderPath = config.targetFolderPath;
        sessionStorage.setItem("videoExportPath", targetFolderPath);
    }
    
    toast.push(m.video_export_export_preset_loaded({ name: exportPreset.name }), { classes: ['toast-success'] });
}
</script>

<div transition:fade={{duration: 100}} 
     class="modal {modalState.selected === 'videoExport' ? 'show d-block' : ''}" 
     role="dialog" 
     tabindex="-1" 
     id="VideoExportModal"
     aria-labelledby="videoExportTitle"
     aria-modal="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="videoExportTitle">{m.video_export_title()}</h4>
                <button type="button" 
                        class="btn-close" 
                        id="videoExportCloseBtn"
                        aria-label={m.video_export_close_label()} 
                        onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                {#if exporting}
                <p role="status" aria-live="polite">
                    <i class="bi bi-exclamation-diamond-fill" aria-hidden="true"></i>
                    {m.video_export_keep_open_warning()}
                </p>
                {/if}
                
                <!-- Two Column Layout -->
                <div class="row">
                    <!-- Left Column - Export Settings -->
                    <div class="col-md-6">
                        <!-- Main Export Form -->
                        <form onsubmit={preventDefault(exportVideo)}>
                            <div id="targetFolderInputGroup" class="mb-3 p-3 border border-secondary rounded">
                                <p class="lead" id="exportLocationLabel">{m.video_export_location_label()}</p>
                                <button type="button" 
                                        id="chooseFolderBtn"
                                        disabled={exporting} 
                                        class="btn btn-info text-white" 
                                        onclick={selectTargetFolder}
                                        aria-labelledby="exportLocationLabel">
                                    <i class="bi bi-folder" aria-hidden="true"></i> {m.video_export_choose_folder_button()}
                                </button>
                                <span class="ms-2 font-italic text-truncate" role="status" aria-live="polite">
                                    {targetFolderPath || m.video_export_no_folder_selected()}
                                </span>
                                {#if !targetFolderPath}
                                    <small class="form-text text-muted" id="folderHelp">{m.video_export_folder_help()}</small>
                                {/if}
                            </div>  
                            
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <label class="form-label" for="eventGroupSelect">{m.video_export_event_group_label()}</label>
                                    <select class="form-select" 
                                            id="eventGroupSelect" 
                                            bind:value={eventGroup}
                                            aria-describedby="eventGroupHelp">
                                        {#each eventGroupState as eventGroupOption}
                                        <option value={eventGroupOption.id} selected={eventGroup === eventGroupOption.id}>
                                            {eventGroupOption.name}
                                        </option>
                                        {/each}
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label" for="presetSelect">{m.video_export_export_preset_label()}</label>
                                    <select class="form-select" id="presetSelect" bind:value={preset}>
                                        {#each ffmpegPresets.presets as ffmpegPreset}
                                            <option value={ffmpegPreset.id} selected>{ffmpegPreset.displayName}</option>
                                        {/each}                   
                                    </select>
                                </div>
                            </div>
                            
                            <!-- Segment / Range Export -->
                            <div id="segmentExportGroup" class="mb-3 p-3 border border-secondary rounded">
                                <div class="form-check form-switch">
                                    <input class="form-check-input"
                                           type="checkbox"
                                           role="switch"
                                           id="exportSegmentCheck"
                                           bind:checked={exportSegment}
                                           disabled={exporting || mediaDuration <= 0}
                                           aria-describedby="exportSegmentHelp">
                                    <label class="form-check-label" for="exportSegmentCheck">
                                        <i class="bi bi-scissors" aria-hidden="true"></i> {m.video_export_segment_toggle()}
                                    </label>
                                </div>
                                {#if mediaDuration <= 0}
                                    <small class="form-text text-muted" id="exportSegmentHelp">{m.video_export_segment_unknown_duration()}</small>
                                {:else if !exportSegment}
                                    <small class="form-text text-muted" id="exportSegmentHelp">{m.video_export_segment_help()}</small>
                                {:else}
                                    <div class="mt-3">
                                        <TcRangeSlider bind:startSec={rangeStartSec}
                                                       bind:endSec={rangeEndSec}
                                                       durationSec={mediaDuration}
                                                       disabled={exporting} />
                                    </div>
                                {/if}
                            </div>

                            <!-- Style Panel Toggle -->
                            <div class="mb-3">
                                <button type="button" 
                                        class="btn btn-outline-dark" 
                                        onclick={() => showStylePanel = !showStylePanel}
                                        disabled={exporting}>
                                    <i class="bi bi-palette" aria-hidden="true"></i> 
                                    {showStylePanel ? m.video_export_style_toggle_hide() : m.video_export_style_toggle_show()}
                                </button>
                            </div>
                            
                            <!-- Style Panel -->
                            {#if showStylePanel}
                            <div class="border border-secondary rounded p-3 mb-3">
                                <h6 class="text-primary">{m.video_export_style_title()}</h6>
                                
                                <!-- Style Controls -->
                                <div class="row g-2 mb-3">
                                    <div class="col-md-4">
                                        <label class="form-label small" for="fontFamilySelect">{m.video_export_font_family_label()}</label>
                                        <select id="fontFamilySelect" 
                                                class="form-select form-select-sm" 
                                                bind:value={styleState.fontFamily}
                                            aria-label={m.video_export_font_family_aria()}>
                                            {#each fontState as font (font.id)}
                                                <option value={font.name} style="font-family: {font.name};">{font.name}</option>
                                            {/each}
                                            <!-- Default system fonts -->
                                            <option value="Arial" style="font-family: Arial;">Arial</option>
                                            <option value="Verdana" style="font-family: Verdana;">Verdana</option>
                                            <option value="Helvetica" style="font-family: Helvetica;">Helvetica</option>
                                            <option value="Tahoma" style="font-family: Tahoma;">Tahoma</option>
                                            <option value="Trebuchet MS" style="font-family: Trebuchet MS;">Trebuchet MS</option>
                                            <option value="Times New Roman" style="font-family: Times New Roman;">Times New Roman</option>
                                            <option value="Georgia" style="font-family: Georgia;">Georgia</option>
                                            <option value="Garamond" style="font-family: Garamond;">Garamond</option>
                                            <option value="Courier New" style="font-family: Courier New;">Courier New</option>
                                            <option value="Brush Script MT" style="font-family: Brush Script MT;">Brush Script MT</option>
                                            <option value="serif" style="font-family: serif;">serif</option>
                                            <option value="sans-serif" style="font-family: sans-serif;">sans-serif</option>
                                            <option value="monospace" style="font-family: monospace;">monospace</option>
                                            <option value="cursive" style="font-family: cursive;">cursive</option>
                                            <option value="fantasy" style="font-family: fantasy;">fantasy</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2">
                                        <label class="form-label small" for="fontSizeInput">{m.video_export_font_size_label()}</label>
                                        <input id="fontSizeInput" 
                                               type="number" 
                                               class="form-control form-control-sm" 
                                               min="8" 
                                               step="1" 
                                               max="72" 
                                               bind:value={styleState.fontSize}
                                               aria-label={m.video_export_font_size_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="fontColorInput">{m.video_export_font_color_label()}</label>
                                        <input id="fontColorInput" type="color" class="form-control form-control-sm" bind:value={styleState.color} aria-label={m.video_export_font_color_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="textOpacityInput">{m.video_export_opacity_label()}</label>
                                        <input id="textOpacityInput" type="number" class="form-control form-control-sm" min="1" step="1" max="100" bind:value={styleState.opacity} aria-label={m.video_export_opacity_aria()}/>
                                    </div>
                                </div>
                                
                                <div class="row g-2 mb-3">
                                    <div class="col-md-3">
                                        <label class="form-label small" for="outlineColorInput">{m.video_export_outline_color_label()}</label>
                                        <input id="outlineColorInput" type="color" class="form-control form-control-sm" bind:value={styleState.outlineColor} aria-label={m.video_export_outline_color_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="outlineOpacityInput">{m.video_export_outline_opacity_label()}</label>
                                        <input id="outlineOpacityInput" type="number" class="form-control form-control-sm" min="1" step="1" max="100" bind:value={styleState.outlineOpacity} aria-label={m.video_export_outline_opacity_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="outlineInput">{m.video_export_outline_size_label()}</label>
                                        <input id="outlineInput" type="number" class="form-control form-control-sm" min="0" step="0.1" bind:value={styleState.outline} aria-label={m.video_export_outline_size_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="letterSpacingInput">{m.video_export_letter_spacing_label()}</label>
                                        <input id="letterSpacingInput" type="number" class="form-control form-control-sm" min="0" step="1" bind:value={styleState.spacing} aria-label={m.video_export_letter_spacing_aria()}/>
                                    </div>
                                </div>
                                
                                <div class="row g-2 mb-3">
                                    <div class="col-md-3">
                                        <label class="form-label small" for="shadowColorInput">{m.video_export_shadow_color_label()}</label>
                                        <input id="shadowColorInput" type="color" class="form-control form-control-sm" bind:value={styleState.shadowColor} aria-label={m.video_export_shadow_color_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="shadowOpacityInput">{m.video_export_shadow_opacity_label()}</label>
                                        <input id="shadowOpacityInput" type="number" class="form-control form-control-sm" min="1" step="1" max="100" bind:value={styleState.shadowOpacity} aria-label={m.video_export_shadow_opacity_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="shadowInput">{m.video_export_shadow_size_label()}</label>
                                        <input id="shadowInput" type="number" class="form-control form-control-sm" min="0" step="0.1" bind:value={styleState.shadow} aria-label={m.video_export_shadow_size_aria()}/>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label small" for="borderStyleInput">{m.video_export_border_style_label()}</label>
                                        <select id="borderStyleInput" class="form-select form-select-sm" bind:value={styleState.borderStyle} aria-label={m.video_export_border_style_aria()}>
                                            <option value="1">{m.video_export_border_style_outline_shadow()}</option>
                                            <option value="3">{m.video_export_border_style_solid_background()}</option>
                                        </select>
                                    </div>
                                </div>
                                
                                <div class="row g-2 mb-3">
                                    <div class="col-md-4">
                                        <label class="form-label small" for="xPaddingInput">{m.video_export_horizontal_padding_label()}</label>
                                        <input id="xPaddingInput" type="number" class="form-control form-control-sm" min="0" max="50" step="0.1" bind:value={styleState.xPadding} aria-label={m.video_export_horizontal_padding_aria()}/>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label small" for="yPaddingInput">{m.video_export_vertical_padding_label()}</label>
                                        <input id="yPaddingInput" type="number" class="form-control form-control-sm" min="0" max="50" step="0.1" bind:value={styleState.yPadding} aria-label={m.video_export_vertical_padding_aria()}/>
                                    </div>
                                </div>
                                
                                <!-- Preset Management -->
                                <div class="row g-2 align-items-end">
                                    <div class="col-md-6">
                                        <label class="form-label small" for="presetSelect">{m.video_export_style_preset_label()}</label>
                                        <select id="stylePresetSelect" 
                                                class="form-select form-select-sm" 
                                                bind:value={styleState.selectedPreset} 
                                                onchange={() => selectPreset()}
                                            aria-label={m.video_export_style_preset_aria()}>
                                            {#each styleState.presets as preset (preset.id)}
                                            <option value={preset}>{preset.name}</option>
                                            {/each}
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <button type="button" class="btn btn-sm btn-success w-100" onclick={() => savePreset()}>
                                            <i class="bi bi-floppy" aria-hidden="true"></i> {m.video_export_style_save_preset()}
                                        </button>
                                    </div>
                                    <div class="col-md-3">
                                        <button type="button" class="btn btn-sm btn-danger w-100" onclick={() => deletePreset()} disabled={!styleState.selectedPreset}>
                                            <i class="bi bi-trash" aria-hidden="true"></i> {m.video_export_style_delete_preset()}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/if}
                            
                        </form>
                    </div>
                    
                    <!-- Right Column - Subtitle Preview -->
                    <div class="col">
                        <div class="border border-secondary rounded p-3 h-100">
                            <h6 class="text-primary mb-3">{m.video_export_preview_title()}</h6>
                            
                            <!-- Preview Controls -->
                            <div class="mb-3">
                                <div class="row g-1 align-items-end">                                    
                                    <div class="col-1">
                                        <button type="button" 
                                                class="btn btn-sm btn-outline-dark w-100"
                                                onclick={goToStart}
                                                disabled={generatingPreview || exporting || selectedEventIndex === 0}
                                                title={m.video_export_preview_go_to_first_title()}
                                                aria-label={m.video_export_preview_go_to_start_aria()}>
                                            <i class="bi bi-skip-start" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-1">
                                        <button type="button" 
                                                class="btn btn-sm btn-outline-dark w-100"
                                                onclick={goToPrevious}
                                                disabled={generatingPreview || exporting || selectedEventIndex === 0}
                                                title={m.video_export_preview_go_to_previous_title()}
                                                aria-label={m.video_export_preview_previous_aria()}>
                                            <i class="bi bi-skip-backward" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-1">
                                        <button type="button" 
                                                class="btn btn-sm btn-outline-dark w-100"
                                                onclick={goToNext}
                                                disabled={generatingPreview || exporting || selectedEventIndex >= ((eventGroupState.find(g => g.id === eventGroup)?.events?.length || 1) - 1)}
                                                title={m.video_export_preview_go_to_next_title()}
                                                aria-label={m.video_export_preview_next_aria()}>
                                            <i class="bi bi-skip-forward" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-1">
                                        <button type="button" 
                                                class="btn btn-sm btn-outline-dark w-100"
                                                onclick={goToEnd}
                                                disabled={generatingPreview || exporting || selectedEventIndex >= ((eventGroupState.find(g => g.id === eventGroup)?.events?.length || 1) - 1)}
                                                title={m.video_export_preview_go_to_last_title()}
                                                aria-label={m.video_export_preview_go_to_end_aria()}>
                                            <i class="bi bi-skip-end" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-4">
                                        <label class="form-label small" for="eventNumberInput">{m.video_export_preview_event_number_label()}</label>
                                        <input id="eventNumberInput" 
                                               type="number" 
                                               class="form-control form-control-sm" 
                                               min="1" 
                                               max={eventGroupState.find(g => g.id === eventGroup)?.events?.length || 1}
                                               value={selectedEventIndex + 1}
                                               oninput={(e) => selectedEventIndex = Math.max(0, Math.min(parseInt(e.target.value) - 1, (eventGroupState.find(g => g.id === eventGroup)?.events?.length || 1) - 1))}
                                               aria-label={m.video_export_preview_event_number_aria()}/>
                                    </div>
                                    <div class="col-4">
                                        <button type="button" 
                                                class="btn btn-sm btn-primary w-100"
                                                onclick={generateVideoPreview}
                                                disabled={generatingPreview || exporting}>
                                            {#if generatingPreview}
                                                <i class="bi bi-hourglass-split" aria-hidden="true"></i>
                                            {:else}
                                                <i class="bi bi-camera" aria-hidden="true"></i>
                                            {/if}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Preview Image -->
                            <div class="preview-container position-relative">
                                {#if previewImageSrc}
                                    <img src={previewImageSrc} alt={m.video_export_preview_image_alt()} class="img-fluid border rounded w-100" style="max-height: 300px; object-fit: contain;">
                                    <!-- Magnify Button -->
                                    <button type="button" 
                                            class="btn btn-sm btn-secondary position-absolute" 
                                            style="top: 8px; right: 8px; opacity: 0.8;"
                                            onclick={() => showMagnifiedPreview = true}
                                            title={m.video_export_preview_magnify_title()}
                                            aria-label={m.video_export_preview_magnify_aria()}>
                                        <i class="bi bi-zoom-in" aria-hidden="true"></i>
                                    </button>
                                {:else if generatingPreview}
                                    <div class="d-flex justify-content-center align-items-center bg-light rounded" style="height: 200px;">
                                        <BarLoader size="60" color="#1eb4b2" unit="px" duration="2s"></BarLoader>
                                    </div>
                                {:else}
                                    <div class="bg-light d-flex align-items-center justify-content-center rounded" style="height: 200px;">
                                        <span class="text-muted">{m.video_export_preview_generate_hint()}</span>
                                    </div>
                                {/if}
                            </div>
                            
                            <!-- Current Event Info -->
                            {#if eventGroupState.find(g => g.id === eventGroup)?.events?.[selectedEventIndex]}
                                {@const currentEvent = eventGroupState.find(g => g.id === eventGroup).events[selectedEventIndex]}
                                <div class="mt-3 p-2 bg-light rounded subtitlePreview">
                                    <div class="text-wrap EditorPreviewText text-center" style="font-size: 0.875rem; max-height: 60px; overflow-y: auto;">
                                        {@html currentEvent.text || `<p>${m.video_export_preview_empty_event()}</p>`}
                                    </div>
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
                
                {#if retry}
                <p class='text-warning'><i class="bi bi-exclamation-triangle"></i> {m.video_export_retry_warning({ tempDir })}</p>
                {/if}
                {#if exporting}
                <div class="progress w-75 float-start mt-2" role="progressbar" 
                     aria-valuemin="0" 
                     aria-valuemax="100" 
                     aria-valuenow={progress}
                     aria-label={m.video_export_progress_aria()}>
                    <div class="progress-bar bg-primary progress-bar-striped progress-bar-animated" 
                         style="width: {progress}%;">
                        {m.video_export_progress_label({ progress, fps })}
                    </div>
                </div>
                <br/>
                <p class="float-start text-muted" role="status" aria-live="polite">
                    <i class="bi bi-info-circle" aria-hidden="true"></i> {statusMsg}
                </p>
                {/if}
            </div>
            
            <!-- Modal Footer -->
            <div class="modal-footer">
                <div class="me-auto d-flex gap-2">
                    <button
                        class="btn btn-outline-secondary"
                        type="button"
                        onclick={showLoadExportPresetDialog}
                        disabled={exporting}
                        title={m.video_export_footer_load_preset_title()}>
                        <i class="bi bi-folder-open" aria-hidden="true"></i> {m.video_export_footer_load_preset_button()}
                    </button>
                    <button
                        class="btn btn-outline-secondary"
                        type="button"
                        onclick={saveAsExportPreset}
                        disabled={exporting}
                        title={m.video_export_footer_save_preset_title()}>
                        <i class="bi bi-save" aria-hidden="true"></i> {m.video_export_footer_save_preset_button()}
                    </button>
                </div>
                <button type="button" 
                        class="btn btn-secondary" 
                        onclick={hideModal}
                        disabled={exporting}>
                    {m.video_export_cancel_button()}
                </button>
                <button type="button" 
                        disabled={!targetFolderPath || exporting || (exportSegment && !segmentActive)} 
                        class="btn btn-primary" 
                        onclick={exportVideo}>
                    <i class="bi bi-download" aria-hidden="true"></i> {m.video_export_export_button()}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Magnified Preview Overlay -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
{#if showMagnifiedPreview && previewImageSrc}
<!-- svelte-ignore a11y_interactive_supports_focus -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div class="modal show d-block" 
     style="background-color: rgba(0,0,0,0.8); z-index: 1060;" 
     onclick={() => showMagnifiedPreview = false}
     role="dialog"
    aria-label={m.video_export_magnified_aria()}>
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="modal-dialog modal-xl modal-dialog-centered" onclick={(e) => e.stopPropagation()}>
        <div class="modal-content bg-transparent border-0">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title text-white">{m.video_export_magnified_title()}</h5>
                <button type="button" 
                        class="btn-close btn-close-white" 
                        onclick={() => showMagnifiedPreview = false}
                        aria-label={m.video_export_magnified_close_label()}></button>
            </div>
            <div class="modal-body text-center">
                <img src={previewImageSrc} 
                     alt={m.video_export_magnified_image_alt()} 
                     class="img-fluid rounded shadow-lg" 
                     style="max-height: 80vh; max-width: 100%; object-fit: contain;">
            </div>
            <div class="modal-footer border-0 pt-0 justify-content-between align-items-center">
                <small class="text-white-50">
                    {m.video_export_magnified_event_hint({ index: selectedEventIndex + 1 })}
                </small>
                <button type="button" 
                        class="btn btn-success btn-sm"
                        onclick={downloadPreviewThumbnail}
                        title={m.video_export_magnified_download_title()}
                        aria-label={m.video_export_magnified_download_aria()}>
                    <i class="bi bi-download" aria-hidden="true"></i> {m.video_export_magnified_download_button()}
                </button>
            </div>
        </div>
    </div>
</div>
{/if}

<style lang="css">
#targetFolderInputGroup {
    background-color: #00000014;
}

.preview-container:hover .btn {
    opacity: 1 !important;
}

.subtitlePreview {
    min-height: 5rem;
}
</style>
